import { render, staticRenderFns } from "./UICreatePortfolioModalv2.vue?vue&type=template&id=32daa6c0&scoped=true"
import script from "./UICreatePortfolioModalv2.vue?vue&type=script&lang=js"
export * from "./UICreatePortfolioModalv2.vue?vue&type=script&lang=js"
import style0 from "./UICreatePortfolioModalv2.vue?vue&type=style&index=0&id=32daa6c0&prod&lang=scss"
import style1 from "./UICreatePortfolioModalv2.vue?vue&type=style&index=1&id=32daa6c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32daa6c0",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InfoIcon: require('/skade-pwa/components/ui/atom/InfoIcon.vue').default,Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
